import * as suuid from 'short-uuid'
import { AudioResource, ImageResource } from './Resource'
import Scene from './Scene'
import Message from './Message'
/**
 * @typedef {import('./Game').Game} Game
 */
/**
 * @typedef {import('./Scene').Scene} Scene
 */
/**
 * @callback InstallCallback
 * @param {Game} game
 */
/**
 * @callback EventCallback
 * @param {Game} game
 * @param {*} data
 */
/**
 * 表示一個對話劇本
 */
export class Screenplay{
  /**
   * TODO 修改callback的相關說明
   * @typedef {Screenplay|{
   *  onInput: EventCallback,,
   *  onAfterInput: EventCallback
   *  onEvent: EventCallback,
   *  onAfterEvent: EventCallback,
   *  onInstall: InstallCallback
   * }} ScreenplayOptions
   */
  /**
   * @param {ScreenplayOptions} opts
   */
  constructor(opts = {}){
    /** @type {Game} */
    this._game = null
    const { Scene } = require('./Scene')
    /** @type {{ audios: AudioResource[], images: ImageResource[] }} */
    this.resources = {
      audios: [],
      images: []
    }
    if(opts.resources){
      if(opts.resources.audios){
        this.resources.audios = opts.resources.audios.map((data)=>{
          return new AudioResource(data)
        })
      }
      if(opts.resources.images){
        this.resources.images = opts.resources.images.map((data)=>{
          return new ImageResource(data)
        })
      }
    }
    /**
     * 表示劇本類型，若為編輯器做成的則為null，手刻則會有不同註記
     * @type {?string}
     */
    this.special = opts.special || null
    /**
     * 劇本ID
     * @type {string}
     */
    this.id = opts.id
    /**
     * 劇本名稱
     * @type {string}
     */
    this.name = opts.name || 'untitled'
    /**
     * 劇本描述
     * @type {string}
     */
    this.description = opts.description || 'no description'
    /**
     * author
     * @type {object}
     */
    this.author = opts.author || null
    /** @type {Scene[]} */
    this.scenes = opts.scenes || []
    this.scenes = this.scenes.map((scene)=>{
      return new Scene(scene)
    })
    /**
     * 暫時儲存資料用
     * 不序列化該欄位
     * @property {Object}
     * @name Screenplay#data
     */
    Object.defineProperty(this, 'data', {
      enumerable: false,
      value: opts.data || {}
    })
    this._onInput = opts.onInput || doNothing
    this._onAfterInput = opts.onAfterInput || doNothing
    this._onEvent = opts.onEvent || doNothing
    this._onAfterEvent = opts.onAfterEvent || doNothing
    this._onInstall = opts.onInstall || doNothing
  }
  /**
   * @params {Game} game
   */
  onInstall(game){
    // TODO .............
    this._game = game
    this._onInstall(game)
  }
  /**
   * @params {Game} game
   */
  onUninstall(game){
    // TODO .............
    this._game = null
  }
  get authorName(){
    if(this.author && typeof this.author === 'object'){
      return this.author.name || this.author.id
    }
    return this.author
  }
  async onInput(game, data){
    await this._onInput(game, data)
    if(game.currentScene && !data.stop){
      await game.currentScene.onInput(game, data)
    }
    if(!data.stop){
      await this._onAfterInput(game, data)
    }
  }
  async onEvent(game, data){
    await this._onEvent(game, data)
    if(game.currentScene && !data.stop){
      await game.currentScene.onEvent(game, data)
    }
    if(!data.stop){
      await this._onAfterEvent(game, data)
    }
  }
  validate(){
    // TODO
  }
  toJSON(){
    let obj = { ...this }
    delete obj._game
    return obj
  }

  static generateDefaultScreenplay(opts = {}){
    // TODO id之後要檢查有沒有重複
    let screenplay = new Screenplay({
      id: opts.id || suuid.generate()
    })
    let scene = Scene.generate({
      id: 'START'
    })
    screenplay.scenes.push(scene)
    return screenplay
  }
}
function doNothing(){}

export default Screenplay
